var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconVoip = function SvgIconVoip(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 2.3,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VoIP_Preferences",
    transform: "translate(-120.000000, -43.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Old-Dock-/-Nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(102.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 16.660000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3157895,9.28421053 L14.2105263,9.28421053 C14.2105263,6.21206526 11.6611579,3.71368421 8.52631579,3.71368421 L8.52631579,5.57052632 C10.6162105,5.57052632 12.3157895,7.23611368 12.3157895,9.28421053",
    id: "Fill-1787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52631579,0 L8.52631579,1.85684211 C12.7051579,1.85684211 16.1052632,5.18894526 16.1052632,9.28421053 L18,9.28421053 C18,4.16489684 13.7501053,0 8.52631579,0",
    id: "Fill-1788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52631579,7.42736842 L8.52631579,9.28421053 L10.4210526,9.28421053 C10.4210526,8.25923368 9.57221053,7.42736842 8.52631579,7.42736842",
    id: "Fill-1789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1578947,12.0694737 L11.3684211,12.0694737 C10.8445263,12.0694737 10.4210526,12.4844779 10.4210526,12.9978947 L10.4210526,13.9263158 C6.63157895,13.9263158 3.84821053,11.0834905 3.78947368,7.42736842 L4.73684211,7.42736842 C5.26073684,7.42736842 5.68421053,7.01236421 5.68421053,6.49894737 L5.68421053,2.78526316 C5.68421053,2.27184632 5.26073684,1.85684211 4.73684211,1.85684211 L0.947368421,1.85684211 C0.423473684,1.85684211 0,2.27184632 0,2.78526316 L0,7.42736842 C0,13.0675263 4.66578947,17.64 10.4210526,17.64 L15.1578947,17.64 C15.6817895,17.64 16.1052632,17.2249958 16.1052632,16.7115789 L16.1052632,12.9978947 C16.1052632,12.4844779 15.6817895,12.0694737 15.1578947,12.0694737",
    id: "Fill-1790"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconVoip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-voip.56ae3aaaaecd832dee205c61fce41634.svg";